import { UploadStatusType } from '~/enums/UploadStatusType';
import { intlService } from '~/i18n/IntlService';
import { pilot } from '~/services/serviceInstances';
import { DocumentField, VisibilityLevel } from '~/types/Document';
import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

import { List } from '../ApiTypes';
import { camelizeKeys, ParsedType } from '../transformers/utils';

type ViewSetFieldApi = {
  field_id: PilotId | string;
  field_name: string;
};

const getOtherDocumentFields = (): ViewSetFieldApi[] => [
  {
    field_id: 'document_group_id',
    field_name: intlService.getIntl().formatMessage({
      id: 'postSigDocument.documentGroup',
      defaultMessage: 'Document Group',
      description: 'Field name for document group',
    }),
  },
];

export type ViewSetField = ParsedType<ViewSetFieldApi>;

type FolderDataItem = {
  id: PilotId;
  name: string;
  file_type: string;
  date_added: string;
  date_modified: string;
  document_id: null;
  user_added: string;
  type: 'document' | 'folder';
  document_fields: DocumentField[];
  processing_status: Nullable<UploadStatusType>;
  user_visibility_level: VisibilityLevel;
  document_types: string[];
  children_count_top_level: { folder: number; document: number };
};

export const getDocumentsViewsetFields = async ({
  hasDocumentGroupPermission,
}: {
  hasDocumentGroupPermission: boolean;
}): Promise<ViewSetField[]> => {
  const viewSetField = (await pilot.get(
    'viewset/fields/',
  )) as ViewSetFieldApi[];

  const documentFields = hasDocumentGroupPermission
    ? [...viewSetField, ...getOtherDocumentFields()]
    : viewSetField;

  return documentFields.map((value) => camelizeKeys(value));
};

export const getFolderData = ({
  folderId,
  order,
  orderBy,
  page,
  pageSize,
}: {
  folderId: Nullable<PilotId>;
  orderBy: string;
  order: string;
  page: number;
  pageSize: number;
}): Promise<List<FolderDataItem>> => {
  const contentUrl = folderId
    ? `folder/content/${folderId}/?order_by_field=${orderBy}&order=${order}&page=${page}&page_size=${pageSize}`
    : `folder/content/?order_by_field=${orderBy}&order=${order}&page=${page}&page_size=${pageSize}`;
  return pilot.get(contentUrl);
};
